var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpenInNewWindow = function SvgOpenInNewWindow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 11.7 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M3.833.5h-2C1.39.5.5.767.5 1.833v8.334c0 .333.267 1 1.333 1h8c.445 0 1.334-.2 1.334-1V7.833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.48 5.48a.5.5 0 1 0 .707.707zM11.667.5a.5.5 0 0 0-.5-.5h-4.5a.5.5 0 0 0 0 1h4v4a.5.5 0 0 0 1 0zm-5.48 5.687L11.52.854l-.707-.708L5.48 5.48z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpenInNewWindow);
export default ForwardRef;